import React, { useState, useEffect, useMemo } from 'react';
import { getdata, TIMEDATA, DAILYAVAILABLETIME, CLOSEDDATA, formatdate, getdate,updatedata, sendwhatsappmessage, WAITINGGIF} from "../../util/global";


const SendMessageForm = ({ showmodal, setshowmodal, formdata, setformdata, handlesubmit, phonenumberdata, messagedata }) => {
    
  useEffect(() => { 
  }, [showmodal, messagedata]);

  if (showmodal != "showsendmessageform" ) return null;
  
  formdata.senderphonenumber =  formdata.phonenumber;
  if (messagedata?.length > 0 && !formdata.receiverphonenumber) {
    formdata.receiverphonenumber = messagedata[0].receiverphonenumber[0]?.phonenumber || "";
    formdata.message = messagedata[0].message || "";
  }

  const sendmessage = async () => {
    let phonenumber = formdata.receiverphonenumber.split(",");
    $("#waitinggif").show();
    let payload = {
                senderid:formdata._id,
                senderphonenumber:formdata.senderphonenumber, 
                receiverphonenumber:[], 
                message:formdata.message, 
                };
    for (let i=0; i < phonenumber.length;i++) { 
      payload.receiverphonenumber.push({phonenumber: phonenumber[i]});
    }
    console.log(payload);
    await sendwhatsappmessage(payload);
    setshowmodal("");
  };



  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>{formdata.name} {formdata.senderphonenumber}</h3>
          <button className="close-btn" onClick={() => setshowmodal(false)}>&times;</button>
        </div>
        <div className="modal-body">
          <label>API Code</label>
          <textarea
                    readOnly // Keeps users from typing and breaking the snippet text
                    rows={16} // Sets the vertical footprint size to prevent squishing
                    className="code-snippet-textarea"
                    style={{
                      width: '100%',
                      fontFamily: 'monospace',
                      backgroundColor: 'grey',
                      fontSize:'10px',
                      color: '#d4d4d4',
                      padding: '12px',
                      borderRadius: '4px',
                      height:'100px',
                      border: '1px solid #333',
                      resize: 'none'
                    }}
                    value={`fetch('http://44.254.125.221/sendwhatsappmessage', {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
                  'Authorization': 'Bearer ${window.APPUSER?.user?.token || 'YOUR_TOKEN_HERE'}'
              },
              body: JSON.stringify({
                  senderid:"${formdata._id}",
                  senderphonenumber: "${formdata.senderphonenumber}",
                  receiverphonenumber: [{ phonenumber: "91XXXXXXXXXX" }],
                  message: "Hello from the API!"
              }),
          })
          .then(response => response.json())
          .then(data => console.log('Success:', data))
          .catch(error => console.error('Error:', error));`}
                  />
          <div className="form-group">
            <label>Send To Phone Number</label>
            <input 
              type="text" 
              className="form-input" 
              value={formdata.receiverphonenumber } 
              onChange={(e) => setformdata({...formdata, receiverphonenumber: e.target.value})} 
            />              
          </div>
           <div className="form-group">
            <label>Message</label>
            <textarea 
              type="text" 
              className="form-input" 
              value={formdata.message ? formdata.message: messagedata[0]?.message} 
              onChange={(e) => setformdata({...formdata, message: e.target.value})} 
            />              
          </div>
        
          <button className="btn-blue full-width " onClick={() => {sendmessage();}}>
            {formdata._id ? "Proceed" : "Proceed"} <img id="waitinggif" src="/css/whatsappapi/waiting.gif" style={{display:'none', width:'25px',position:'absolute'}}/>
          </button>
        </div>
      </div>
    </div>
  );
};

export default SendMessageForm;
